import React from 'react';

const IconAnswerCorrect = () => {
	return (
		<svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<circle cx='7.54205' cy='7.39581' r='6.56598' fill='url(#icoAnswC)' />
			<path
				d='M10.0324 4.23965L6.24458 8.02775L4.6662 6.44918L3.40381 7.71167L6.24458 10.5523L11.2948 5.50214L10.0324 4.23965Z'
				fill='white'
			/>
			<defs>
				<linearGradient
					id='icoAnswC'
					x1='6.60441'
					y1='3.01863'
					x2='9.57492'
					y2='13.9618'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#53F22B' />
					<stop offset='1' stopColor='#259808' />
				</linearGradient>
			</defs>
		</svg>
	);
};

export default IconAnswerCorrect;
